import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { Module } from 'vuex';
import { RootStateShape, FeatureStateShape } from 'store';

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
} as Module<FeatureStateShape, RootStateShape>;
